module.exports = __webpack_public_path__ + "media/images/samples/300x300/7-fbde2be91c7fd6dccb1f1db36f607c75.jpg";